export const EntityPrefix = {
    OBJECT: 'bj',
    GOODS_SERVICE: 'gs',
};
export const formatEntityNumber = (prefix, internalNumber) => {
    if (internalNumber == null || String(internalNumber).trim() === '')
        return '';
    return `${prefix}-${internalNumber}`;
};
